import React, { useState } from 'react';

export type ModalContextType = {
    modal: string | null;
    setModal: (modal: string) => void;
    modalOpen: boolean;
    setModalOpen: (modalOpen: boolean) => void;
    auth0: string | null;
    setAuth0: (auth0: string | null) => void;
    loginRedirectPath: string | null;
    setLoginRedirectPath: (loginRedirectPath: string | null) => void;
    loginMetrics: any;
    setLoginMetrics: (loginMetrics: any) => void;
    leadInLogin: boolean;
    setLeadInLogin: (leadInLogin: boolean) => void;
    leadInPopup: boolean;
    setLeadInPopup: (leadInPopup: boolean) => void;
    isPayWall: boolean;
    setIsPayWall: (isPaywall: boolean) => void;
    regWall: any;
    setRegWall: (regWall: any) => void;
    layoutType: string;
    setLayoutType: (layoutType: string) => void;
    errorPage: boolean;
    setErrorPage: (errorPage: boolean) => void;
    timer: number;
    setTimer: (timer: number) => void;
};

const ModalContext = React.createContext<ModalContextType>({
    modal: null,
    setModal: () => {},
    modalOpen: false,
    setModalOpen: () => {},
    auth0: null,
    setAuth0: () => {},
    loginRedirectPath: null,
    setLoginRedirectPath: () => {},
    loginMetrics: {},
    setLoginMetrics: () => {},
    leadInLogin: false,
    setLeadInLogin: () => {},
    leadInPopup: false,
    setLeadInPopup: () => {},
    isPayWall: false,
    setIsPayWall: () => {},
    regWall: {},
    setRegWall: () => {},
    layoutType: 'login',
    setLayoutType: () => {},
    errorPage: false,
    setErrorPage: () => {},
    timer: 0,
    setTimer: () => {},
});

export const ModalProvider = ({ children }) => {
    const [modal, setModal] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [auth0, setAuth0] = useState<string | null>(null);
    const [loginMetrics, setLoginMetrics] = useState(null);
    const [leadInLogin, setLeadInLogin] = useState(false);
    const [leadInPopup, setLeadInPopup] = useState(false);
    const [isPayWall, setIsPayWall] = useState(false);
    const [regWall, setRegWall] = useState({});
    const [layoutType, setLayoutType] = useState('create');
    const [loginRedirectPath, setLoginRedirectPath] = React.useState<
        string | null
    >(null);
    const [timer, setTimer] = React.useState(0);
    const [errorPage, setErrorPage] = useState(false);
    return (
        <ModalContext.Provider
            value={{
                modal,
                setModal,
                modalOpen,
                setModalOpen,
                auth0,
                setAuth0,
                loginMetrics,
                setLoginMetrics,
                leadInLogin,
                setLeadInLogin,
                leadInPopup,
                setLeadInPopup,
                isPayWall,
                setIsPayWall,
                regWall,
                setRegWall,
                layoutType,
                setLayoutType,
                loginRedirectPath,
                setLoginRedirectPath,
                timer,
                setTimer,
                errorPage,
                setErrorPage,
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export const UseModalState = () => {
    const context = React.useContext(ModalContext);

    if (!context) {
        throw new Error('You need to wrap ModalStateProvider.');
    }

    return context;
};
